import { render } from "./MockContent.vue?vue&type=template&id=19de189d&scoped=true"
import script from "./MockContent.vue?vue&type=script&lang=ts"
export * from "./MockContent.vue?vue&type=script&lang=ts"

import "./MockContent.vue?vue&type=style&index=0&id=19de189d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-19de189d"

export default script